import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import React from 'react';

import {
  tooltipContainerSx,
  tooltipDotSx,
  tooltipDurationSx,
  tooltipHeaderSx,
  tooltipHeaderTextSx,
  tooltipLabelSx,
  tooltipOverflowSx,
  tooltipPercentageSx,
  tooltipRowSx,
} from './chart.styles';

export interface ChartTooltipRow {
  color: string;
  label: string;
  duration: string;
  percentage?: string;
}

interface Props {
  title: string;
  total: string;
  rows: ChartTooltipRow[];
  overflow?: number;
}

const ChartTooltip: React.FC<Props> = ({ title, total, rows, overflow }) => (
  <Box sx={tooltipContainerSx}>
    <Box sx={tooltipHeaderSx}>
      <Typography sx={tooltipHeaderTextSx}>{title}</Typography>
      <Typography sx={tooltipHeaderTextSx}>{total}</Typography>
    </Box>

    {rows.map((row, i) => (
      <Box key={i} sx={tooltipRowSx}>
        <Box sx={tooltipDotSx(row.color)} />
        <Typography sx={tooltipLabelSx}>{row.label}</Typography>
        <Typography sx={tooltipDurationSx}>{row.duration}</Typography>
        {row.percentage && (
          <Typography sx={tooltipPercentageSx}>{row.percentage}</Typography>
        )}
      </Box>
    ))}

    {overflow != null && overflow > 0 && (
      <Typography sx={tooltipOverflowSx}>
        +{overflow} more — click chart to see all
      </Typography>
    )}
  </Box>
);

export default ChartTooltip;
